module.exports = __webpack_public_path__ + "img/bg-us-2.88e26a6f.png";